import { axios } from '../../lib'

export const getUser = () => {
    return axios.get('/auth')
}